/**
 * Multi-variant product form — keep price, ATC state, and URL in sync with
 * the selected option. Gallery image sync lives in product-gallery.js.
 */
(function () {
  function init() {
    const select = document.getElementById('ProductSelect');
    if (!select) return;

    const priceEl = document.getElementById('ProductPrice');
    const form = document.getElementById('ProductForm');
    const submitBtn = form?.querySelector('button[data-add-to-cart]');
    const diyBadges = document.querySelector('[data-diy-badges]');
    const builtBadges = document.querySelector('[data-built-badges]');
    const addLabel = select.dataset.labelAddToCart || 'Add to cart';
    const soldOutLabel = select.dataset.labelSoldOut || 'Sold out';

    function sync(updateUrl) {
      const option = select.selectedOptions[0];
      if (!option) return;

      if (priceEl && option.dataset.priceFormatted) {
        priceEl.textContent = option.dataset.priceFormatted;
      }

      if (diyBadges) {
        diyBadges.hidden = option.dataset.diy !== 'true';
      }
      if (builtBadges) {
        builtBadges.hidden = option.dataset.diy === 'true';
      }

      const available = option.dataset.available !== 'false';
      if (submitBtn) {
        submitBtn.disabled = !available;
        submitBtn.textContent = available ? addLabel : soldOutLabel;
      }

      if (updateUrl && option.value) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url.toString());
      }
    }

    select.addEventListener('change', () => sync(true));
    sync(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
